import cx from 'classnames'
import { ObModal } from '@outbound-ai/ursa'
import styled, { css, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components'
interface IProps {
  toggler?: JSX.Element | string
  children: React.ReactNode | React.ReactNode[]
  modalHeader?: JSX.Element | JSX.Element[] | string
  modalFooter?: JSX.Element | JSX.Element[] | string
  show: boolean
  maxWidth?: string
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  style?: ModalStyle
  hidden?: boolean
  disabled?: boolean
}

interface ModalStyle {
  headerheight?: string
  headerstyles?: FlattenInterpolation<ThemeProps<DefaultTheme>>
  bodystyles?: FlattenInterpolation<ThemeProps<DefaultTheme>>
  showCloseButton?: boolean
}

export const ReusableModal = ({
  toggler,
  children,
  modalHeader,
  modalFooter,
  show,
  maxWidth,
  setShow,
  style,
  hidden = false,
  disabled,
}: IProps) => {
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const hideHeader = !modalHeader

  return (
    <>
      {hidden
        ? toggler
        : toggler && (
            <span className={cx({ inactive: disabled })} onClick={handleShow}>
              {toggler}
            </span>
          )}

      <StyledObModal
        show={show}
        close={handleClose}
        title={modalHeader}
        modalFooter={modalFooter}
        hideCloseButton={!style?.showCloseButton}
        $headerheight={style?.headerheight}
        $headerstyles={style?.headerstyles}
        $bodystyles={style?.bodystyles}
        $maxwidth={maxWidth}
        $hideheader={hideHeader}
      >
        <div className="reusable-modal-body">{children}</div>
      </StyledObModal>
    </>
  )
}

const StyledObModal = styled(ObModal)<{
  $maxwidth?: string
  $headerstyles?: any
  $bodystyles?: any
  $headerheight?: string
  $hideheader?: boolean
}>`
  .custom-modal {
    overflow: hidden;
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
  }

  ${({ $maxwidth }) =>
    $maxwidth &&
    css`
      .custom-modal {
        max-width: ${$maxwidth};
        width: 100%;
        margin: 0 auto;
      }
    `}

  .modal-header {
    height: ${(props) => (props.$headerheight ? props.$headerheight : 'auto')};
    background-color: ${({ theme }) => theme.colors.info.lighter};
    color: ${({ theme }) => theme.colors.primary.darker};
    ${({ theme }) => theme.typography.m.normal};
    font-weight: ${({ theme }) => theme.fontWeight.bold};

    ${({ $headerstyles }) => $headerstyles && $headerstyles}
  }

  .ob-modal-content,
  .reusable-modal-body {
    padding: 0;
    ${({ $bodystyles }) => $bodystyles && $bodystyles}
  }

  ${({ $hideheader }) =>
    $hideheader &&
    css`
      .modal-header {
        display: none;
      }
    `}
`
